"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _FormGroup = _interopRequireDefault(require("../FormGroup"));

var _Label = _interopRequireDefault(require("../Label"));

var _utils = require("../../utils");

var _utils2 = require("./utils");

require("./NumberInput.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** A basic widget for getting the user input is a number field with formatter.
 * Keyboard and mouse can be used for providing or changing data.
 *
 * DO Always use labels on text inputs and don’t depend on the placeholder
 * text. If there is more information for the text input needed make
 * use of a paragraph on top or use an info box. */
function NumberInput(props) {
  var suffix = props.suffix,
      prefix = props.prefix,
      thousandsGroupStyle = props.thousandsGroupStyle,
      validation = props.validation,
      disabled = props.disabled,
      error = props.error,
      errorIcon = props.errorIcon,
      errorInTooltip = props.errorInTooltip,
      label = props.label,
      labelInfobox = props.labelInfobox,
      required = props.required,
      questionmark = props.questionmark,
      verified = props.verified,
      children = props.children,
      value = props.value,
      decimalSeparator = props.decimalSeparator,
      thousandSeparator = props.thousandSeparator,
      onChange = props.onChange,
      precision = props.precision,
      withSelectBox = props.withSelectBox,
      helpText = props.helpText,
      rest = _objectWithoutProperties(props, ["suffix", "prefix", "thousandsGroupStyle", "validation", "disabled", "error", "errorIcon", "errorInTooltip", "label", "labelInfobox", "required", "questionmark", "verified", "children", "value", "decimalSeparator", "thousandSeparator", "onChange", "precision", "withSelectBox", "helpText"]);

  var _useState = (0, _react.useState)(getInitialValue(value)),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setState(getInitialValue(value));
  }, [value]);
  (0, _react.useEffect)(function () {
    if (decimalSeparator === thousandSeparator) {
      throw new Error('Privided Decimal and Thousand are equal. Use various separators!');
    }
  }, [decimalSeparator, thousandSeparator]);
  (0, _react.useEffect)(function () {
    if (inputRef && inputRef.current) {
      inputRef.current.addEventListener('mouseup', handleMouseUp);
    }

    return function () {
      inputRef.current.removeEventListener('mouseup', handleMouseUp);
    };
  }, [inputRef]); // todo fix me
  // eslint-disable-next-line no-unused-vars

  var iconProps = {
    errorInTooltip: errorInTooltip,
    error: error,
    errorIcon: errorIcon,
    questionmark: questionmark,
    verified: verified
  };

  function getAllowedDecimentalSeparators() {
    return [decimalSeparator];
  }

  function updateCaretPosition(position) {
    inputRef.current.selection = position;
    inputRef.current.selectionStart = position;
    inputRef.current.selectionEnd = position;
  }

  function formatAsNumber(numStr) {
    var hasDecimalSeparator = numStr.indexOf('.') !== -1; // eslint-disable-next-line prefer-const

    var _splitDecimal = (0, _utils2.splitDecimal)(numStr),
        beforeDecimal = _splitDecimal.beforeDecimal,
        afterDecimal = _splitDecimal.afterDecimal,
        addNegation = _splitDecimal.addNegation;

    afterDecimal = (0, _utils2.limitToPrecision)(afterDecimal, precision);

    if (thousandSeparator) {
      beforeDecimal = (0, _utils2.applyThousandSeparator)(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }

    if (prefix) beforeDecimal = prefix + beforeDecimal;
    if (suffix) afterDecimal = afterDecimal + suffix;
    if (addNegation) beforeDecimal = "-".concat(beforeDecimal); // eslint-disable-next-line no-mixed-operators

    numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
    return numStr;
  }

  function formatNumString(numStr) {
    var formattedValue = numStr;

    if (numStr === '') {
      formattedValue = '';
    } else if (numStr === '-') {
      formattedValue = '-';
    } else {
      formattedValue = formatAsNumber(formattedValue);
    }

    return formattedValue;
  }

  function getInitialValue(initial) {
    var value = !initial || typeof initial === 'boolean' // eslint-disable-next-line no-restricted-globals
    || isNaN(initial) || initial === Infinity || initial === -Infinity ? '' : formatNumString((0, _utils2.roundToPrecision)(String(initial), precision));
    return {
      value: value,
      raw: removeFormatting(value)
    };
  }

  function removeFormatting(value) {
    if (!value) return value;
    return getFloatString(removePrefixAndSuffix(value));
  }

  function removePrefixAndSuffix(val) {
    if (!val) return val;
    var isNegative = val[0] === '-';
    if (isNegative) val = val.substring(1, val.length);
    val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;
    var suffixLastIndex = val.lastIndexOf(suffix);
    val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val;
    if (isNegative) val = "-".concat(val);
    return val;
  }

  function getFloatString() {
    var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var numRegex = getNumberRegex(true);
    var hasNegation = num[0] === '-';
    if (hasNegation) num = num.replace('-', '');

    if (decimalSeparator && precision === 0) {
      // eslint-disable-next-line prefer-destructuring
      num = num.split(decimalSeparator)[0];
    }

    num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');
    var firstDecimalIndex = num.indexOf(decimalSeparator);

    if (firstDecimalIndex !== -1) {
      num = "".concat(num.substring(0, firstDecimalIndex), ".").concat(num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), ''));
    }

    if (hasNegation) num = "-".concat(num);
    return num;
  }

  function escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  }

  function getNumberRegex(g, ignoreDecimalSeparator) {
    // eslint-disable-next-line prefer-template
    return new RegExp('\\d' + (decimalSeparator && precision !== 0 && !ignoreDecimalSeparator ? '|' + escapeRegExp(decimalSeparator) : ''), g ? 'g' : undefined);
  }

  function isCharacterAFormat(caretPos, value) {
    if (caretPos < prefix.length || caretPos >= value.length - suffix.length) {
      return true;
    }

    return false;
  }

  function checkIfFormatGotDeleted(start, end, value) {
    for (var i = start; i < end; i++) {
      if (isCharacterAFormat(i, value)) return true;
    }

    return false;
  }

  function formatNegation() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');
    var hasNegation = negationRegex.test(value);
    var removeNegation = doubleNegationRegex.test(value);
    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation) {
      value = "-".concat(value);
    }

    return value;
  }

  function correctInputValue(caretPosition, lastValue, value) {
    var selectionStart = 0,
        selectionEnd = 0;
    var lastRaw = state.raw || '';

    var _findChangedIndex = (0, _utils2.findChangedIndex)(lastValue, value),
        start = _findChangedIndex.start,
        end = _findChangedIndex.end;

    if (start === end && getAllowedDecimentalSeparators().indexOf(value[selectionStart]) !== -1) {
      var separator = precision === 0 ? '' : decimalSeparator;
      return value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length);
    }

    var leftBound = prefix.length;
    var rightBound = lastValue.length - suffix.length;

    if (value.length > lastValue.length || !value.length || start === end || selectionStart === 0 && selectionEnd === lastValue.length || selectionStart === leftBound && selectionEnd === rightBound) {
      return value;
    }

    if (checkIfFormatGotDeleted(start, end, lastValue)) {
      value = lastValue;
    }

    var numericString = removeFormatting(value); // eslint-disable-next-line prefer-const

    var _splitDecimal2 = (0, _utils2.splitDecimal)(numericString),
        beforeDecimal = _splitDecimal2.beforeDecimal,
        afterDecimal = _splitDecimal2.afterDecimal,
        addNegation = _splitDecimal2.addNegation;

    var isBeforeDecimalPoint = caretPosition < value.indexOf(decimalSeparator) + 1;

    if (numericString.length < lastRaw.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) {
      return addNegation ? '-' : '';
    }

    return value;
  }

  function formatInput(value) {
    value = removePrefixAndSuffix(value);
    value = formatNegation(value);
    value = removeFormatting(value);
    return formatNumString(value) || '';
  }

  function correctCaretPosition(value, caretPos) {
    if (value === '') return 0;
    caretPos = (0, _utils2.clamp)(caretPos, 0, value.length);
    var hasNegation = value[0] === '-';
    return (0, _utils2.clamp)(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
  }

  function getCaretPosition(inputValue, formattedValue, caretPos) {
    var value = state.value;
    var numRegex = getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j = 0;
    var i;

    for (i = 0; i < caretPos; i++) {
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || '';

      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) {
        // eslint-disable-next-line no-continue
        continue;
      }

      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }

      j++;
    }

    if (!value) {
      j = formattedValue.length;
    }

    j = correctCaretPosition(formattedValue, j);
    return j;
  }

  function handleMouseUp(_ref) {
    var _ref$target = _ref.target,
        selectionStart = _ref$target.selectionStart,
        selectionEnd = _ref$target.selectionEnd,
        _ref$target$value = _ref$target.value,
        value = _ref$target$value === void 0 ? '' : _ref$target$value;

    if (selectionStart === selectionEnd) {
      var caretPosition = correctCaretPosition(value, selectionStart);
      updateCaretPosition(caretPosition);
    }
  }

  function updateValue(_ref2) {
    var formattedValue = _ref2.formattedValue,
        raw = _ref2.rawValue,
        corrected = _ref2.corrected,
        target = _ref2.target,
        caretPosition = _ref2.caretPosition,
        _ref2$setCaretPositio = _ref2.setCaretPosition,
        setCaretPosition = _ref2$setCaretPositio === void 0 ? true : _ref2$setCaretPositio;
    var lastValue = state.value || '';

    if (target) {
      if (setCaretPosition) {
        if (!caretPosition) {
          var inputValue = corrected || target.value;
          var currentCaretPosition = (0, _utils2.getCurrentCaretPosition)(target);
          /**
           * This is required if new caret position is beyond prev val
           * caret position won't be set correctly
           */

          target.value = formattedValue;
          caretPosition = getCaretPosition(inputValue, formattedValue, currentCaretPosition);
        }

        updateCaretPosition(caretPosition);
      }
    }

    if (raw === undefined) {
      raw = removeFormatting(formattedValue);
    }

    if (formattedValue !== lastValue) {
      setState(function () {
        return {
          value: formattedValue,
          raw: raw
        };
      });
      onChange(raw);
    }
  }

  function isValid(value, type, num) {
    if (typeof num !== 'number' || value === '-' || value === decimalSeparator) {
      return true;
    }

    switch (type) {
      case 'maxValue':
        return value <= num;

      case 'minValue':
        return value >= num;

      default:
        return true;
    }
  }

  function getValidated(value, _ref3) {
    var minValue = _ref3.minValue,
        maxValue = _ref3.maxValue;
    if (!isValid(value, 'minValue', minValue)) return String(minValue);
    if (!isValid(value, 'maxValue', maxValue)) return String(maxValue);
    return String(value);
  }

  function getValidatedFormattedValue(value, _ref4) {
    var minValue = _ref4.minValue,
        maxValue = _ref4.maxValue;
    var val = removeFormatting(value);

    if (isValid(val, 'minValue', minValue) && isValid(val, 'maxValue', maxValue)) {
      return value;
    }

    return getValidated(val, {
      minValue: minValue,
      maxValue: maxValue
    });
  }

  function getValidatedRawValue(value, validation) {
    var validated = getValidated(value, validation);
    return validated;
  }

  function handleChange(_ref5) {
    var target = _ref5.target,
        value = _ref5.target.value;
    var lastValue = state.value || '';
    var currentCaretPosition = (0, _utils2.getCurrentCaretPosition)(target);
    var corrected = correctInputValue(currentCaretPosition, lastValue, value);
    var formattedValue = getValidatedFormattedValue(formatInput(corrected), validation);
    var rawValue = getValidatedRawValue(removeFormatting(formattedValue), validation);
    updateValue({
      formattedValue: formattedValue,
      rawValue: rawValue,
      corrected: corrected,
      target: target
    });
  }

  var classNames = (0, _utils.getClassNames)({
    TextInput_invalid: error,
    'with-select-box': withSelectBox
  });
  return /*#__PURE__*/_react.default.createElement(_FormGroup.default, {
    disabled: disabled,
    error: error
  }, label && /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: label,
    label: label,
    labelInfobox: labelInfobox,
    required: required,
    helpText: helpText
  }), /*#__PURE__*/_react.default.createElement(_TextInput.default, _extends({}, rest, {
    id: label,
    ref: inputRef,
    value: state.value,
    className: classNames,
    errorInTooltip: errorInTooltip,
    error: error,
    disabled: disabled,
    required: required,
    onChange: handleChange,
    precision: precision,
    defaultValue: value
  }), children));
}

NumberInput.propTypes = {
  /** The label text */
  label: _propTypes.default.string,

  /** The text displayed if the label tooltip exist */
  labelInfobox: _propTypes.default.bool,

  /** The placeholder text */
  placeholder: _propTypes.default.string,

  /** @ignore */
  value: _propTypes.default.string,

  /** @ignore */
  disabled: _propTypes.default.bool,

  /** If required field* */
  required: _propTypes.default.bool,

  /** The error message displayed if the input is errored */
  error: _propTypes.default.string,

  /** If the space does not allow show error message below the input
   *  make use of the red error indicator with tooltip. */
  errorIcon: _propTypes.default.bool,

  /** The error message displayed is tooltip */
  errorInTooltip: _propTypes.default.bool,

  /** Whether the input field has questionmark icon */
  questionmark: _propTypes.default.bool,

  /** Whether the input field has verified icon */
  verified: _propTypes.default.bool,

  /** @ignore */
  addonAfter: _propTypes.default.string,

  /** @ignore */
  children: _propTypes.default.node,

  /** @ignore */
  precision: _propTypes.default.number,

  /** @ignore */
  suffix: _propTypes.default.string,

  /** @ignore */
  prefix: _propTypes.default.string,

  /** @ignore */
  thousandsGroupStyle: _propTypes.default.string,

  /** Callback function that is executed when when value is changed,
   it provides stringified float value (without prefix or suffix) */
  onChange: _propTypes.default.func,

  /** Callback function that is executed when when value is changed,
   it provides stringified input value (incledes prefix or suffix) */
  getFormattedValue: _propTypes.default.func,

  /** @ignore */
  withSelectBox: _propTypes.default.bool,

  /** You can provide validation rules.
   * It's gonna check min or max and return it if validation has been failed */
  validation: _propTypes.default.arrayOf(_propTypes.default.shape({
    maxValue: _propTypes.default.number,
    minValue: _propTypes.default.number
  })),

  /** Decimal sepearator */
  decimalSeparator: _propTypes.string,

  /** Thousand Separator */
  thousandSeparator: _propTypes.string,

  /** The text displayed if the label tooltip exist */
  helpText: _propTypes.default.bool
};
NumberInput.defaultProps = {
  suffix: '',
  prefix: '',
  thousandsGroupStyle: 'thousand',
  label: null,
  labelInfobox: false,
  placeholder: null,
  value: '',
  disabled: false,
  required: false,
  error: null,
  errorIcon: false,
  errorInTooltip: false,
  questionmark: false,
  verified: false,
  addonAfter: null,
  children: null,
  precision: 2,
  onChange: function onChange(v) {
    return v;
  },
  getFormattedValue: function getFormattedValue(v) {
    return v;
  },
  withSelectBox: false,
  validation: {
    maxValue: null,
    minValue: null
  },
  decimalSeparator: ',',
  thousandSeparator: '.',
  helpText: null
};
var _default = NumberInput;
exports.default = _default;